import { render, staticRenderFns } from "./VideoIntro.vue?vue&type=template&id=a3b45a0e&scoped=true&"
import script from "./VideoIntro.vue?vue&type=script&lang=ts&"
export * from "./VideoIntro.vue?vue&type=script&lang=ts&"
import style0 from "./VideoIntro.vue?vue&type=style&index=0&id=a3b45a0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3b45a0e",
  null
  
)

component.options.__file = "VideoIntro.vue"
export default component.exports